var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilities1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_11_1",
    "data-name": "Component 11 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 103.953,
    height: 116.799,
    viewBox: "0 0 103.953 116.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 103.953,
    height: 116.799,
    fill: "none",
    stroke: "#e0e1e5",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92-2",
    "data-name": "Rectangle 92",
    width: 103.953,
    height: 116.799,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x1: 39.273,
    y1: 0.016,
    transform: "translate(32.213 107.583)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M41.078,52.653l16.256.005-.228,4.128",
    transform: "translate(30.402 38.97)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M64.464.65V47.571a6.319,6.319,0,1,1-12.638,0v-3.6",
    transform: "translate(38.357 0.482)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M7.341,107.1l-6.686.024L.65,91.78l12.731-7.864L10.149,71.6,102.341.65",
    transform: "translate(0.481 0.482)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M36.7,30.962l-21.181,17.3,8.788,20.443",
    transform: "translate(11.488 22.917)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x1: 44.885,
    y2: 36.659,
    transform: "translate(57.937 9.259)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M21.728,59.341v-15.7l10.853-.021,8.979,15.725",
    transform: "translate(16.082 32.282)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 36.377,
    transform: "translate(21.265 91.623)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M49.149,57.2a8.068,8.068,0,1,1-8.067,8.069A8.078,8.078,0,0,1,49.149,57.2",
    transform: "translate(30.406 42.333)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M12.562,57.2a8.068,8.068,0,1,1-8.067,8.069A8.078,8.078,0,0,1,12.562,57.2",
    transform: "translate(3.327 42.333)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 14.427,
    y2: 49.47,
    transform: "translate(52.368 48.239)",
    fill: "none",
    stroke: "#e0e1e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_50-2",
    "data-name": "Line 50",
    x1: 39.273,
    y1: 0.016,
    transform: "translate(32.213 107.583)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218-2",
    "data-name": "Path 218",
    d: "M41.078,52.653l16.256.005-.228,4.128",
    transform: "translate(30.402 38.97)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39-2",
    "data-name": "Group 39",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38-2",
    "data-name": "Group 38",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219-2",
    "data-name": "Path 219",
    d: "M64.464.65V47.571a6.319,6.319,0,1,1-12.638,0v-3.6",
    transform: "translate(38.357 0.482)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220-2",
    "data-name": "Path 220",
    d: "M7.341,107.1l-6.686.024L.65,91.78l12.731-7.864L10.149,71.6,102.341.65",
    transform: "translate(0.481 0.482)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221-2",
    "data-name": "Path 221",
    d: "M36.7,30.962l-21.181,17.3,8.788,20.443",
    transform: "translate(11.488 22.917)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51-2",
    "data-name": "Line 51",
    x1: 44.885,
    y2: 36.659,
    transform: "translate(57.937 9.259)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222-2",
    "data-name": "Path 222",
    d: "M21.728,59.341v-15.7l10.853-.021,8.979,15.725",
    transform: "translate(16.082 32.282)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52-2",
    "data-name": "Line 52",
    x2: 36.377,
    transform: "translate(21.265 91.623)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223-2",
    "data-name": "Path 223",
    d: "M49.149,57.2a8.068,8.068,0,1,1-8.067,8.069A8.078,8.078,0,0,1,49.149,57.2",
    transform: "translate(30.406 42.333)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224-2",
    "data-name": "Path 224",
    d: "M12.562,57.2a8.068,8.068,0,1,1-8.067,8.069A8.078,8.078,0,0,1,12.562,57.2",
    transform: "translate(3.327 42.333)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53-2",
    "data-name": "Line 53",
    x2: 14.427,
    y2: 49.47,
    transform: "translate(52.368 48.239)",
    fill: "none",
    stroke: "#d1914c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilities1);
export default __webpack_public_path__ + "static/media/utilities1.91339a539cb0ea81550c256c2d2af617.svg";
export { ForwardRef as ReactComponent };